import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, Component } from "vue";
import store from "@/store";

import { DesktopEvaluationTheme, MobileEvaluationTheme } from ".";

import type {
  EvaluationType,
  EvaluationListType,
} from "@/common/types/evaluation";

interface TabListType {
  [key: string]: {
    key: string;
    icon: string;
    label: string;
    component: Component;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'evaluation',
  props: {
    accountId: {},
    evaluationId: {},
    evaluation: {},
    evaluations: {},
    tabList: {},
    menuList: {},
    isEdit: { type: Boolean }
  },
  emits: ["update-data", "add", "input-search", "search"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const listMenu = computed(() =>
  props.menuList.reduce((acc, item) => {
    const modules = store.getters.modules;

    if (modules.find((mod) => mod.code === `${item.key.toUpperCase()}_NOT`)) {
      return acc;
    } else {
      acc.push(item);
    }

    return acc;
  }, []),
);

return (_ctx: any,_cache: any) => {
  return (!_ctx.$store.getters.mobile)
    ? (_openBlock(), _createBlock(_unref(DesktopEvaluationTheme), {
        key: 0,
        "is-edit": __props.isEdit,
        "account-id": __props.accountId,
        "evaluation-id": __props.evaluation?.evaluation_id || null,
        evaluation: __props.evaluation,
        evaluations: __props.evaluations,
        "tab-list": __props.tabList,
        "menu-list": listMenu.value,
        onUpdateData: _cache[0] || (_cache[0] = ($event: any) => (emit('update-data'))),
        onAdd: _cache[1] || (_cache[1] = ($event: any) => (emit('add'))),
        onInputSearch: _cache[2] || (_cache[2] = ($event: any) => (emit('input-search', $event))),
        onSearch: _cache[3] || (_cache[3] = ($event: any) => (emit('search', $event)))
      }, null, 8, ["is-edit", "account-id", "evaluation-id", "evaluation", "evaluations", "tab-list", "menu-list"]))
    : (_openBlock(), _createBlock(_unref(MobileEvaluationTheme), {
        key: 1,
        "is-edit": __props.isEdit,
        "account-id": __props.accountId,
        "evaluation-id": __props.evaluation?.evaluation_id || null,
        evaluation: __props.evaluation,
        evaluations: __props.evaluations,
        "tab-list": __props.tabList,
        "menu-list": __props.menuList,
        onUpdateData: _cache[4] || (_cache[4] = ($event: any) => (emit('update-data'))),
        onAdd: _cache[5] || (_cache[5] = ($event: any) => (emit('add'))),
        onInputSearch: _cache[6] || (_cache[6] = ($event: any) => (emit('input-search', $event))),
        onSearch: _cache[7] || (_cache[7] = ($event: any) => (emit('search', $event)))
      }, null, 8, ["is-edit", "account-id", "evaluation-id", "evaluation", "evaluations", "tab-list", "menu-list"]))
}
}

})